import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { PhonePage } from "@/features/onboarding/pages/phone-page";

export const Route = createFileRoute("/onboarding/_guarded/phone")({
	head: () => pageTitle("Your Mobile Phone Number"),
	component: PhonePage,
});
